export const CurrentArtist = {
    get: () => !!(window as any).TOURTRACKS ? (window as any).TOURTRACKS.currentArtistId || "" : "",
    set: (artistId: string) => {
        (window as any).TOURTRACKS = (window as any).TOURTRACKS || {};
        (window as any).TOURTRACKS.currentArtistId = artistId
    },
    // get: () => localStorage.getItem('currentArtist'),
    // set: (artistId: string) => localStorage.setItem('currentArtist', artistId),
}